export const messages = {
  en: {
    translations: {
      titles: {
        home: "HOME",
        skills: "Skills",
        exp: "Exp",
        projects: "Projects",
        contact: "Contact",
      },
      main: {
        banner: "Welcome to my portfolio!",
        title: `Hi! I'm Gabriel Gomes`,
        info: `I have always been passionate about technology and I love to know how everything works! 
        Although I especially like Front-end development, I'm interested in almost everything related to the world of programming. 
        I try to study and practice whenever possible, after all, the technology area is fueled by constant movement. Can't stand still.`,
        interests: "I have an especial interest in:",
      },
      skills: {
        description: "Here are my courses and certifications",
      },
      exp: {
        description: "This is my journey as a Dev (until now)",
        expTime: {
          expUticketTime: "Sep 2023 - Sep 2024",
          expStoneTime: "Sep 2024 - Now",
        },
      },
      projects: {
        description: "Here are some of my personal projects",
      },
      contact: {
        description: `I'm await your contact!`,
        fields: "Resumé",
      },
      footer: {
        title: "developed by gabrigomez",
        description: "2023 - All rights reserved",
      },
    },
  },
};
